import {jsxs as _jsxs, jsx as _jsx} from "react/jsx-runtime";import styled from '@emotion/styled'
import {PALETTE} from 'parabol-client/styles/paletteV3'
import {ExternalLinks} from '../types/constEnums'

import PlainButton from './PlainButton/PlainButton'






const label = 'Export to CSV'

const Button = styled(PlainButton)({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'flex-end'
})

const Label = styled('div')({
  color: PALETTE.SKY_400,
  fontSize: 14,
  fontWeight: 600
})

const Img = styled('img')({
  paddingRight: 8,
  filter: `sepia(100%) hue-rotate(195deg) saturate(1500%)` // make img blue
})

const ExportToCSVButton = (props) => {
  const {handleClick, corsOptions} = props
  return (
    _jsxs(Button, { onClick: handleClick, children: [
      _jsx(Img, { alt: label, src: `${ExternalLinks.EMAIL_CDN}cloud_download.png`, ...corsOptions,} )
      , _jsx(Label, { children: label})
    ]})
  )
}

export default ExportToCSVButton
